import { render } from "./v-year-filter.vue?vue&type=template&id=398a1332&scoped=true"
import script from "./v-year-filter.vue?vue&type=script&lang=js"
export * from "./v-year-filter.vue?vue&type=script&lang=js"

import "./v-year-filter.vue?vue&type=style&index=0&id=398a1332&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398a1332"]])

export default __exports__